/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import * as XLSX from "xlsx";
import { hasRegistrationNumberFormat } from "./format";

export const isValidExcelColumnsNamingForMultipleVehicles = (
  workSheet: XLSX.WorkSheet,
) => {
  const areMandatoryHeaderFilled =
    workSheet.A1?.h &&
    workSheet.B1?.h &&
    workSheet.C1?.h &&
    workSheet.D1?.h &&
    workSheet.E1?.h;

  const areNoOtherHearders =
    !workSheet.F1?.h &&
    !workSheet.G1?.h &&
    !workSheet.H1?.h &&
    !workSheet.I1?.h;

  const areOptionalHeaderFilled =
    workSheet.F1?.h && workSheet.G1?.h && workSheet.H1?.h && workSheet.I1?.h;

  const areMandatoryHeadersValid =
    workSheet.A1?.h === "Immatriculation" &&
    workSheet.B1?.h === "Référence" &&
    workSheet.C1?.h === "Type de véhicule" &&
    workSheet.D1?.h === "Axe analytique" &&
    workSheet.E1?.h === "Département";

  const areOptionalHeadersValid =
    workSheet.F1?.h === "Surcoût au km" &&
    workSheet.G1?.h === "Date début de contrat" &&
    workSheet.H1?.h === "Date fin de contrat" &&
    workSheet.I1?.h === "Kilométrage contractuel";

  if (areMandatoryHeaderFilled && areNoOtherHearders) {
    return areMandatoryHeadersValid;
  } else if (areMandatoryHeaderFilled && areOptionalHeaderFilled) {
    return areMandatoryHeadersValid && areOptionalHeadersValid;
  }
  return false;
};

export const cellsContentErrorsForMultipleVehicles = (
  workSheet: XLSX.WorkSheet,
  fileSize: number,
) => {
  const cellsErrors: Array<{
    cell: string;
    content: string;
    errorType: string;
  }> = [];

  if (!isValidExcelColumnsNamingForMultipleVehicles(workSheet)) {
    if (workSheet.A1?.h !== "Immatriculation") {
      cellsErrors.push({
        cell: "A1",
        content: workSheet.A1?.h as string,
        errorType: "header",
      });
    }
    if (workSheet.B1?.h !== "Référence") {
      cellsErrors.push({
        cell: "B1",
        content: workSheet.B1?.h as string,
        errorType: "header",
      });
    }
    if (workSheet.C1?.h !== "Type de véhicule") {
      cellsErrors.push({
        cell: "C1",
        content: workSheet.C1?.h as string,
        errorType: "header",
      });
    }
    if (workSheet.D1?.h !== "Axe analytique") {
      cellsErrors.push({
        cell: "D1",
        content: workSheet.D1?.h as string,
        errorType: "header",
      });
    }
    if (workSheet.E1?.h !== "Département") {
      cellsErrors.push({
        cell: "E1",
        content: workSheet.E1?.h as string,
        errorType: "header",
      });
    }
    if (
      (workSheet.F1?.h && workSheet.F1?.h !== "Surcoût au km") ||
      (!workSheet.F1?.h &&
        (workSheet.G1?.h || workSheet.H1?.h || workSheet.I1?.h))
    ) {
      cellsErrors.push({
        cell: "F1",
        content: workSheet.F1?.h as string,
        errorType: "header",
      });
    }
    if (
      (workSheet.G1?.h && workSheet.G1?.h !== "Date début de contrat") ||
      (!workSheet.G1?.h &&
        (workSheet.F1?.h || workSheet.H1?.h || workSheet.I1?.h))
    ) {
      cellsErrors.push({
        cell: "G1",
        content: workSheet.G1?.h as string,
        errorType: "header",
      });
    }
    if (
      (workSheet.H1?.h && workSheet.H1?.h !== "Date fin de contrat") ||
      (!workSheet.H1?.h &&
        (workSheet.F1?.h || workSheet.G1?.h || workSheet.I1?.h))
    ) {
      cellsErrors.push({
        cell: "H1",
        content: workSheet.H1?.h as string,
        errorType: "header",
      });
    }
    if (
      (workSheet.I1?.h && workSheet.I1?.h !== "Kilométrage contractuel") ||
      (!workSheet.I1?.h &&
        (workSheet.F1?.h || workSheet.G1?.h || workSheet.H1?.h))
    ) {
      cellsErrors.push({
        cell: "I1",
        content: workSheet.I1?.h as string,
        errorType: "header",
      });
    }
  }
  const registrationNumbers: string[] = [];
  const references: string[] = [];
  for (let i = 2; i <= fileSize + 1; i++) {
    const cellValueA = workSheet[`A${i}`]?.v as string;
    if (cellValueA && !hasRegistrationNumberFormat(cellValueA)) {
      cellsErrors.push({
        cell: `A${i}`,
        content: cellValueA,
        errorType: "registrationNumber",
      });
    } else {
      registrationNumbers.push(cellValueA);
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const cellValueB = workSheet[`B${i}`]?.v as string;

    if (typeof cellValueB === "number") {
      references.push(cellValueB);
    } else if (typeof cellValueB === "string") {
      if (cellValueB.length > 28) {
        cellsErrors.push({
          cell: `B${i}`,
          content: cellValueB,
          errorType: "reference",
        });
      } else if (hasRegistrationNumberFormat(cellValueB)) {
        cellsErrors.push({
          cell: `B${i}`,
          content: cellValueB,
          errorType: "reference.registrationNumberFormat",
        });
      } else {
        references.push(cellValueB);
      }
    }
    if (!cellValueA && !cellValueB) {
      cellsErrors.push({
        cell: `A${i}`,
        content: cellValueB,
        errorType: "emptyName",
      });
    }
    const cellValueC = workSheet[`C${i}`]?.v as string;
    if (cellValueC) {
      if (
        cellValueC.toUpperCase() !== "MONO-CONDUCTEUR" &&
        cellValueC.toUpperCase() !== "MULTI-CONDUCTEURS"
      ) {
        cellsErrors.push({
          cell: `C${i}`,
          content: cellValueC,
          errorType: "vehicleType",
        });
      }
    } else {
      cellsErrors.push({
        cell: `C${i}`,
        content: cellValueC,
        errorType: "emptyCell",
      });
    }
    const cellValueD = workSheet[`D${i}`]?.v;
    if (cellValueD) {
      if (typeof cellValueD !== "number" && typeof cellValueD !== "string") {
        cellsErrors.push({
          cell: `D${i}`,
          content: cellValueD,
          errorType: "typeOfAnalyticCode",
        });
      }
    }
    const cellValueE = workSheet[`E${i}`]?.v;
    if (cellValueE) {
      if (typeof cellValueE !== "string" && typeof cellValueE !== "number") {
        cellsErrors.push({
          cell: `E${i}`,
          content: cellValueE,
          errorType: "typeOfDepartment",
        });
      }
    }
    const cellValueF = workSheet[`F${i}`]?.v;
    if (workSheet.F1?.h === "Surcoût au km") {
      if (cellValueF) {
        if (typeof cellValueF !== "number") {
          cellsErrors.push({
            cell: `F${i}`,
            content: cellValueF,
            errorType: "typeOfAdditionalCost",
          });
        }
      }
    }
    const cellValueG = workSheet[`G${i}`]?.v as number;
    if (cellValueG) {
      if (typeof cellValueG !== "number" || cellValueG < 25569) {
        cellsErrors.push({
          cell: `G${i}`,
          content: cellValueG.toString(),
          errorType: "typeOfDate",
        });
      }
    }
    const cellValueH = workSheet[`H${i}`]?.v as number;
    if (cellValueH) {
      if (typeof cellValueH !== "number" || cellValueH < 25569) {
        cellsErrors.push({
          cell: `H${i}`,
          content: cellValueH.toString(),
          errorType: "typeOfDate",
        });
      }
    }
    const cellValueI = workSheet[`I${i}`]?.v as number;
    if (cellValueI) {
      if (typeof cellValueI !== "number") {
        cellsErrors.push({
          cell: `I${i}`,
          content: cellValueI,
          errorType: "contratMileage",
        });
      }
    }
  }
  const duplicateRegistrationNumbers = registrationNumbers.filter(
    (item, index) => registrationNumbers.indexOf(item) !== index && item,
  );
  if (duplicateRegistrationNumbers.length > 0) {
    cellsErrors.push({
      cell: `A`,
      content: [...new Set(duplicateRegistrationNumbers)].join(","),
      errorType: "duplicate.registrationNumbers",
    });
  }
  const duplicateReferences = references.filter(
    (item, index) => references.indexOf(item) !== index && item,
  );
  if (duplicateReferences.length > 0) {
    cellsErrors.push({
      cell: `B`,
      content: [...new Set(duplicateReferences)].join(","),
      errorType: "duplicate.references",
    });
  }

  return cellsErrors;
};
